import {
	SET_GIFT_EXCHANGE_DETAIL_ACTION,
	SET_SPECIAL_OFFER_DETAIL_ACTION,
	SET_PROMOTION_DETAIL_ACTION
} from "../actions/ProgramDetailAction/actionTypes";

const initialState = {
	specialOfferDetail: {},
	giftExchangeDetail: {},
	promotionDetail: {}
};

const programDetailReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SPECIAL_OFFER_DETAIL_ACTION: {
			return {
				...state,
				specialOfferDetail: action.params
			};
		}

		case SET_GIFT_EXCHANGE_DETAIL_ACTION: {
			return {
				...state,
				giftExchangeDetail: action.params
			};
		}

		case SET_PROMOTION_DETAIL_ACTION: {
			return {
				...state,
				promotionDetail: action.params
			};
		}

		default:
			return state;
	}
};

export default programDetailReducer;
